<script>
import options from './PostHeaderAddComment.options'
export default options
</script>

<template>
    <article class="kb-component--post-header-add-comment kb-post-header-add-comment kb-stafet-step"
        id="postHeaderAddComment">
        <hr class="kb-stafet-step__breaker-line" />
        <h2 class="kb-post-header-add-comment__title">{{ getLabel('createCommentLabel') }}</h2>
        <div class="kb-post-comment__new-comment-editor">
        <Editor
        v-if="editorReady"
        v-model="newCommentContent"
        :disabled="isSubmitting"
        :init="{
            plugins: 'emoticons autoresize lists autolink',
            toolbar: 'emoticons bold italic underline bullist numlist',
            toolbar_location: 'bottom',
            menubar: false,
            statusbar: false,
            valid_elements: 'a[href|target],strong,em,u,ul,ol,li,p,br',
            formats: {
                bold: { inline: 'strong' },
                italic: { inline: 'em' },
                underline: { inline: 'u' }
            },
            paste_webkit_styles: 'none',
            paste_remove_styles: true,
            paste_remove_spans: true
        }"
        />
        </div>

        <AttachmentsEditor :files="[]" @update:filesToAdd="newCommentFilesToAdd = $event" ref="attachmentsComponent" />

        <template v-if="isSubmitting">
            <div class="kb-spinner-overlay">
                <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
            </div>
        </template>

        <button v-on:click="submitNewComment" class="kb-button kb-button--full-color-spot" :class="{
            'kb-button--disabled': isSubmitButtonDisabled
        }">
            {{ getLabel('submitCommentCtaLabel') }}
        </button>
    </article>
</template>